import { render, staticRenderFns } from "./vote.vue?vue&type=template&id=5c81fc34&scoped=true"
import script from "./vote.vue?vue&type=script&lang=js"
export * from "./vote.vue?vue&type=script&lang=js"
import style0 from "./vote.vue?vue&type=style&index=0&id=5c81fc34&prod&scoped=true&lang=css"
import style1 from "./vote.vue?vue&type=style&index=1&id=5c81fc34&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c81fc34",
  null
  
)

export default component.exports